// @ts-check
import SmrClient from "Utils/Requests/SmrClient";

class DevelopRequests {
    /**
     * @returns {Promise<DeveloperSettings>}
     */
    async GetDeveloperSettings() {
        return await SmrClient.FetchJson({
            url: 'Develop/GetDeveloperSettings',
            method: "GET"
        })
    }

    /**
     * @param {DeveloperSettings} settings 
     * @returns {Promise<VoidResponse>}
     */
    async SaveDeveloperSettings(settings) {
        return await SmrClient.FetchJson({
            url: 'Develop/SaveDeveloperSettings',
            method: "POST",
            body: settings
        })
    }

    /**
     * @returns {Promise<VoidResponse>}
     */
    async SaveStats() {
        return await SmrClient.FetchJson({
            url: 'Develop/SaveStats',
            method: "POST"
        })
    }


}

export default new DevelopRequests;